import { toast } from "sonner";
import { track } from "@/lib/analytics";

const SHARE_TITLE = "Cailève";
const SHARE_TEXT =
  "Style the pieces you already love. I use Cailève to organize my jewelry and build looks from my own collection — thought you'd love it too.";
const SHARE_URL = "https://caileve.app";

const CLIPBOARD_TEXT = `${SHARE_TEXT} ${SHARE_URL}`;

export function useShareCaileve() {
  return async () => {
    track("share_caileve_tapped");
    try {
      if (typeof window !== "undefined" && "share" in navigator) {
        await navigator.share({
          title: SHARE_TITLE,
          text: SHARE_TEXT,
          url: SHARE_URL,
        });
      } else if (typeof window !== "undefined" && "clipboard" in navigator) {
        await navigator.clipboard.writeText(CLIPBOARD_TEXT);
        toast.success("Link copied to clipboard.");
      } else {
        toast.error("Sharing is not supported on this device.");
      }
    } catch {
      // User dismissed the share sheet or clipboard failed silently — no toast needed.
    }
  };
}
